import { InjectableClass } from '@fino/lib-injection';

export class PdfViewerService extends InjectableClass {
  constructor($http, $window, $document) {
    'ngInject';
    super({ $http, $window, $document });
  }

  getPdfDocumentUrl(url) {
    return this.$http({
      method: 'GET',
      url: url,
      params: {
        type: 'redirect',
      },
    });
  }

  loadPdf(url) {
    return this.$http({
      method: 'GET',
      url: url,
    });
  }

  makeBase64Downloadable(base64String) {
    base64String = base64String.replace('data:application/pdf;base64,', '');
    return this.makeItDownloadable(atob(base64String));
  }

  makeItDownloadable(string) {
    const arrrayBuffer = Uint8Array.from(
      string.split('').map((x) => x.charCodeAt()),
    );
    const blob = new Blob([arrrayBuffer], { type: 'application/pdf' });
    return this.$window.URL.createObjectURL(blob);
  }

  downloadIt(url, fileName) {
    const link = this.$document[0].createElement('a');
    link.href = url;
    link.download = fileName;
    this.$document[0].body.appendChild(link);
    link.click();

    this.$document[0].body.removeChild(link);
  }
}
